// ======================================================================
// File Name       : SelectGroupDialogContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import TreeView from '../../components/Tree';
import ModalWrapper from '../../components/modal/ModalWrapper';
import * as groupActions from '../../actions/GroupAction';
import * as Functions from '../../constants/FunctionConstants';
import TREE_ICON from '../../images/tree/default-icon.png';
import { canAccess } from '../../utils/AuthedUtils';
import RenderField from '../../utils/ReduxFormUtils';
import { createTree } from '../../utils/groupUtils';

class SelectGroupDlgContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      data: [],
      groupList: [],
      selectedTargetGroup: {},
      fetchData: false,
    };
    this.handleSelectNode = this.handleSelectNode.bind(this);
    this.onOK = this.onOK.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    if (!this.props.allSecernIds || !this.props.bySecernId || this.props.allSecernIds.length <= 0) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   */
  onOK() {
    const { reportListForm } = this.props;
    if (reportListForm && reportListForm.values) {
      const { selectedTargetGroup } = reportListForm.values;
      this.props.dispatch(groupActions.selectedGroupOnDialog(selectedTargetGroup));
    }
    this.props.hideModal();
  }

  onCancel() {
    this.props.dispatch(change('reportListForm', 'selectedTargetGroup', this.props.selectedTargetGroup));
    this.props.hideModal();
  }

  /**
   * Handle select node
   *
   * @param {*} event
   * @param {object} node
   */
  handleSelectNode(event, nodes) {
    if (!nodes || !nodes.data) return;
    const selectedTargetGroup = nodes.data;
    this.setState({ selectedTargetGroup });
  }

  getModalOptions() {
    return {
      title: 'ユーザーグループを選択してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.onCancel, variant: 'default' },
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const { groupList, selectedTargetGroup } = this.props;
    const nodes = createTree(groupList, false, selectedTargetGroup);
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.onCancel}>
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Col sm={12}>
              <RenderField name={'selectedTargetGroup'} data={nodes} type="tree" />
            </Col>
          </Form>
        </Col>
      </ModalWrapper>
    );
  }
}

SelectGroupDlgContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bySecernId: PropTypes.shape().isRequired,
  allSecernIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { structures, groupList } = state.group;
  const { selectedTargetGroup } = state.group;
  const { reportListForm } = state.form;
  return { ...structures, selectedTargetGroup, reportListForm, groupList };
};

export default connect(mapStateToProps)(SelectGroupDlgContainer);
